export const FileObjectType = {
  SessionContent: 'sessionContent',
  LearningTool: 'learningTool',
  Facilitator: 'facilitator'
} as const;
export type FileObjectType = (typeof FileObjectType)[keyof typeof FileObjectType];

export const FileObjectStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE'
} as const;
export type FileObjectStatus = (typeof FileObjectStatus)[keyof typeof FileObjectStatus];

export interface IFileObjectDTO {
  id: string;
  filename: string;
  mimeType: string;
  type: FileObjectType;
  status?: FileObjectStatus;
  size: number;
  azureUrl: string;
  createdAt?: Date;
  updatedAt: Date;
  thumbnailUrl?: string;
  thumbnailName?: string;
  title?: string;
  placement?: string;
  clientIds?: string[];
  cohortIds?: string[];
}
